import { render } from "./balances.vue?vue&type=template&id=351874b9&ts=true"
import script from "./balances.vue?vue&type=script&lang=ts"
export * from "./balances.vue?vue&type=script&lang=ts"

import "./balances.vue?vue&type=style&index=0&id=351874b9&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__